/* Status Label Directive
 *
 * Angular Module: trackerbase-app.directives.status-label
 * Directive exposed as "tb-status-label" element.
 */
import angular from "angular";

import Assert from "tbAssert";

import StatusClassServiceModule from "../services/StatusClassService";

const mStatusClassSvc = new WeakMap();

const mStatusName = new WeakMap();
const mShowLabelName = new WeakMap();
const mStatusLabelClass = new WeakMap();

class StatusLabelComponentController {
    constructor($scope, StatusClass) {

        Assert.StrictAssert($scope != null, "Assertion Failure: Missing Controller Scope Service Dependency");
        Assert.StrictAssert(StatusClass != null, "Assertion Failure: Missing Status Class Service Dependency");

        mStatusClassSvc.set(this, StatusClass);

        mStatusLabelClass.set(this, StatusClass.getBootstrapStatusLabelType(this.statusName));
    }

    get statusName() {
        return mStatusName.get(this);
    }

    set statusName(updatedVal) {
        mStatusName.set(this, updatedVal);

        let statusClassSvc = mStatusClassSvc.get(this);
        if (statusClassSvc != null) {
            mStatusLabelClass.set(this, statusClassSvc.getBootstrapStatusLabelType(updatedVal));
        }
    }

    get showLabelName() {
        return mShowLabelName.get(this);
    }

    set showLabelName(updatedVal) {
        mShowLabelName.set(this, updatedVal);
    }

    get statusLabelClass() {
        return mStatusLabelClass.get(this);
    }

}

StatusLabelComponentController.$inject = [ "$scope", "StatusClass" ];
const statusLabelComponentTemplate = require("./StatusLabel.tpl.html");

const StatusLabelComponent = {
    name: "tbStatusLabel",
    config: {
        template: statusLabelComponentTemplate,
        bindings: {
            statusName: "<tbStatusName",
            showLabelName: "<tbShowLabelName"
        },
        controller: StatusLabelComponentController,
        controllerAs: "labelCtrl"
    }
};

export default angular
    .module("trackerbase-app.directives.status-label",[
        "ui.bootstrap",
        StatusClassServiceModule
    ])
    .component(StatusLabelComponent.name, StatusLabelComponent.config)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/directives/StatusLabel.js
// module id = LyM5
// module chunks = 1